import React from 'react';
var DropdownContext = React.createContext({
  menuRef: function menuRef() {},
  toggleRef: function toggleRef() {},
  onToggle: function onToggle() {},
  toggleNode: undefined,
  alignEnd: null,
  show: null,
  drop: null
});
export default DropdownContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-overlays/esm/DropdownContext.js
// module id = 200
// module chunks = 0